// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3c3DZ","imageUploader":"EGiftCard_imageUploader__2nvtk"};